<template>
    <div id="sort__task__control">
        <a class="task-sorting-btn cursor-pointer">
            <i class="fas fa-sort"></i>
        </a>
    </div>
</template>

<script>
export default {
    
}
</script>

<style>

</style>